import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { AirwaysExpenseService } from '../../service/airways-expense.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CommonService } from '../../service/common.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-airways-expense-setting-detail',
  templateUrl: './airways-expense-setting-detail.component.html',
  styleUrls: ['./airways-expense-setting-detail.component.scss']
})
export class AirwaysExpenseSettingDetailComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode = PermissionConstants.ViewAirwaysExpenseSetting;
  currentLang: string = this.laasSetting.language;
  airwaysExpense: any;
  forwarderOptions: any[];
  feeTypeOptions: any[];
  currencyOptions: any[];
  statusOptions: any[];
  countryOptions: any[];
  iataAreaOptions: any[];
  isActivatedOptions: any[];
  isShowEditBtn: boolean;
  isShowCancelBtn: boolean;

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
    private commonService: CommonService,
    private dropdownOptionsService: DropdownOptionsService,
    private airwaysExpenseService: AirwaysExpenseService
  ) {
    super(injector);
    this.airwaysExpense =  {};
    this.forwarderOptions = [];
    this.feeTypeOptions = [];
    this.currencyOptions = [];
    this.statusOptions = [];
    this.countryOptions = [];
    this.iataAreaOptions = [];
    this.isActivatedOptions = [];
    this.isShowEditBtn = false;
    this.isShowCancelBtn = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.isActivatedOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];

    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    try{
      this.airwaysExpense = await this.airwaysExpenseService.getAirwaysExpenseDetail(seqNo);
    }catch (err: any) {
      console.log('get airways expense occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.airwaysExpense.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RFQStatus').subscribe({
      next: result => {
        this.statusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonService.getFeeType('Airways').subscribe({
      next: result => {
        this.feeTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.feeTypeCode}-${x.feeTypeName}`,
            value: x.feeTypeCode,
          };
        });
      }
    });

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
      }
    });

    this.dropdownOptionsService.getVCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: x.countryName,
            value: x.countryCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'IATAArea').subscribe({
      next: result => {
        this.iataAreaOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    if (this.airwaysExpense?.status === '1') {
      this.isShowEditBtn = true;
    }
    this.isShowCancelBtn = true;
  }

  goToEdit(event: any): void{
    this.routeStateService.navigateTo('/Setting/AirwaysExpenseSettingEdit', this.airwaysExpense);
  }

  goToSearchPage(): void{
    this.routeStateService.navigateTo('/Setting/AirwaysExpenseSetting');
  }
}
